import { render, staticRenderFns } from "./birthdayRegistry.vue?vue&type=template&id=a7a6fd62&scoped=true&"
import script from "./birthdayRegistry.vue?vue&type=script&lang=js&"
export * from "./birthdayRegistry.vue?vue&type=script&lang=js&"
import style0 from "./birthdayRegistry.vue?vue&type=style&index=0&id=a7a6fd62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a6fd62",
  null
  
)

export default component.exports